import React from 'react';

export default function SectionDivider({ label, className = 'mb-5' }) {
  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <span className="text-[10px] font-bold text-slate-400 uppercase tracking-widest">{label}</span>
      <div className="flex-1 h-px bg-slate-100" />
    </div>
  );
}
